module.exports = __webpack_public_path__ + "img/head-logo.13a263b9.png";